module.exports = __webpack_public_path__ + "assets/img/fusionGateway-module2-3.818661f3.png";